import React from 'react';
import axios from 'axios';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { ReactComponent as Logo } from './logo.svg';

const Invite = ({ setUser }) => {
  const history = useHistory();

  return (
    <Container
      maxWidth="xs"
      component={Paper}
      variant="outlined"
      style={{ marginTop: 32 }}
    >
      <Box mx="auto" my={4}>
        <Logo />
        <Typography variant="h6">Accept invite</Typography>
        <Formik initialValues={{ password: '' }}>
          {({
            isSubmitting,
            setSubmitting,
            setFieldError,
            setFieldTouched,
            values,
          }) => (
            <Form>
              <Field
                type="password"
                name="password"
                placeholder="Password"
                component={TextField}
                fullWidth
                variant="outlined"
                margin="normal"
                required
              />
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={isSubmitting}
                onClick={async () => {
                  setSubmitting(true);
                  try {
                    const { data } = await axios.post(
                      `${process.env.REACT_APP_API_URL}/user/acceptInvite`,
                      {
                        ...Object.fromEntries(
                          new URLSearchParams(document.location.search),
                        ),
                        ...values,
                      },
                    );
                    setUser(data);
                    history.push('/');
                  } catch (err) {
                    setFieldTouched('password', true, false);
                    setFieldError('password', err.response.data.error);
                  }
                  setSubmitting(false);
                }}
              >
                Set password
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Container>
  );
};

export default Invite;
